import { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { NavLink, useNavigate } from "react-router-dom";
import "./Auth.css";

export function Signin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const auth = getAuth();
  const navigate = useNavigate();

  const validatePassword = (password) => {
    if (password.length < 6) {
      setError("Пароль должен быть больше 6 символов");
      return false;
    }
    return true;
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    if (!validatePassword(password)) return;

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log(userCredential);
      setError("");
      setEmail("");
      setPassword("");
      navigate("/search");
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        setError("Пользователь не найден");
      } else if (error.code === "auth/wrong-password") {
        setError("Неверный пароль");
      } else {
        setError("Ошибка авторизации");
      }
    }
  };

  return (
    <div className="center-auth">
      <h2>Maint<span>Mend</span></h2>
      <h1>Авторизация</h1>
      <form onSubmit={handleSignIn}>
        <div className="txt_field">
          <input
            id="email"
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Почта"
            required
          />
          <span></span>
        </div>
        <div className="txt_field">
          <input
            id="password"
            type="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Пароль"
            required
          />
          <span></span>
        </div>
        <button className="form-login__input">Войти</button>
        {error? <p style={{ color: "red" }}>{error}</p> : ""}
        <div className="signup_link">
          Еще не зарегистрированы? <NavLink to="/signup">Зарегистрируйтесь</NavLink>
        </div>
      </form>
    </div>
  );
}